import { render, staticRenderFns } from "./DocumentListPro.vue?vue&type=template&id=06147d8c&scoped=true&"
import script from "./DocumentListPro.vue?vue&type=script&lang=js&"
export * from "./DocumentListPro.vue?vue&type=script&lang=js&"
import style0 from "./DocumentListPro.vue?vue&type=style&index=0&id=06147d8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06147d8c",
  null
  
)

export default component.exports